class EventEmitter{
  _events = {};

  // 添加订阅者
  on(eventName, callback){
    const callbacks = this._events[eventName] || [];
    callbacks.push(callback);
    this._events[eventName] = callbacks;
    return this;
  }
  // 添加单次订阅者
  once(eventName, callback){
    const wrapFn = (...args) => {
      callback.call(this, ...args);
      this.off(eventName, wrapFn);
    }
    wrapFn.l = callback;  //用于off的删除
    this.on(eventName, wrapFn);
    return this;
  }
  // 移除订阅者
  off(eventName, callback){
    // 移除所有事件的全部订阅者
    if (!eventName){
      this._events = {};
      return;
    }

    // 移除指定事件的全部订阅者
    if (!callback){
      this._events[eventName] = null;
    }

    // 移除指定事件的指定订阅者
    this._events[eventName] = this._events[eventName].filter(fn => (
      fn !== callback && fn.l !== callback
    ));
  }
  // 触发事件
  emit(eventName, ...args){
    const listeners = this._events[eventName];
    if (!listeners) return;
    
    // listeners.forEach(fn => fn.call(this, ...args));

    // 反向遍历，防止订阅者在回调中移除自身带来的下标错位
    for (let i = listeners.length - 1; i > -1; --i) {
      listeners[i].call(this, ...args);
    }
  }
}

export const bus = new EventEmitter();
export default EventEmitter;